/* eslint-disable max-len */
import React from 'react';

const PlusIcon = (props: $TSFixMe) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <circle fill="currentColor" cx="10" cy="10" r="10" />
        <polygon
          fill="#FFFFFF"
          points="11 6.11111111 10.9987302 9.22222222 14.1111111 9.22222222 14.1111111 11 10.9987302 11 11 14.1111111 9.22222222 14.1111111 9.22095238 10.9987302 6.11111111 11 6.11111111 9.22222222 9.22095238 9.22095238 9.22222222 6.11111111"
        />
      </g>
    </g>
  </svg>
);

export default PlusIcon;
